import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, IconButton, Typography } from "@mui/material";
import { useAccessibility } from "../../../Store/contexts/AccessibilityContext";
import alertIcon from '../../../assets/images/triangle-exclamation.png';
import { AlertRegisterQuestionsProps } from "../../../interfaces/props/register/AlertRegisterQuestionsProps";
import { sxButtonOptionRecovery, sxTypographyTitle } from "../sxProps";


const AlertRegisterQuestions: React.FC<AlertRegisterQuestionsProps> = ({ formBack, openRegisterQuestions }) => {

  const { textStyleAccessibility, buttonStyleAccessibility, buttonTextStyleAccessibility } = useAccessibility();

  return (
    <div style={textStyleAccessibility} className='width-100  flex-gap-16'>
      <div className='password-recovery-container-text'>
        <div className='width-100'>
          <IconButton aria-label="Voltar" onClick={() => formBack()} type="button">
            <FontAwesomeIcon style={textStyleAccessibility} icon={faArrowLeft} />
          </IconButton>
          <div className='width-100 password-recovery-alert-container-icon'>
            <img src={alertIcon} alt="Icone de alerta." />
          </div>
          <Typography style={textStyleAccessibility} sx={sxTypographyTitle} className='margin-bottom-painel-rigth'>Validação de Dados</Typography>
        </div>
        <div className='container-text-recovery '>
          <span style={{ color: '#4C4C4C', ...textStyleAccessibility}} className='login-text login-text-center'>Para corrigir seus dados e prosseguir com a redefinição de senha, é necessário responder ao questionário para confirmar algumas informações.</span>
        </div>
        <div className='container-text-recovery '>
          <span style={textStyleAccessibility} className='login-text login-text-center'>Importante: caso alguma informação seja respondida de forma equivocada, a redefinição ficará bloqueado por 24 horas. Após esse período, você poderá realizar uma nova tentativa.</span>
        </div>
      </div>
      <div className='width-100'>
        <Button style={buttonStyleAccessibility} sx={sxButtonOptionRecovery} onClick={() => openRegisterQuestions()} variant='contained'>
          <Typography style={buttonTextStyleAccessibility}>INICIAR QUESTIONÁRIO PARA REVALIDAR SEUS DADOS</Typography>
        </Button>
      </div>
    </div>
  )
}

export default AlertRegisterQuestions